import type { PermissionRole } from '../auth/type'
import type { ChannelTypeEnum, OrgTreeType } from '@/api/base/enums'

export enum ChannelPermissionType {
  // 无权限
  NONE = 0,
  // 负责人
  Admin = 1,
  // 成员
  Member = 2,
}

export interface User {
  userId: string
  userName: string
}

export interface Channel {
  _id: string // 唯一key，一般为 ${渠道id-用户id}，正常渠道下为 ${渠道id-''} 用户维度为 ${''-userId}
  id: string // 渠道id
  name: string
  level: number
  organizationLeaderId: string
  organizationLeaderName: string
  userId?: string // 用户id
  userName?: string // 用户名称
  permissionView: ChannelPermissionType
  rolePermission: PermissionRole
  hasPermission: boolean
  children: Channel[]
  users?: User[]

  _path?: Channel[] // 渠道路径，用户类型底下的多层级渠道记录
  _channelType?: ChannelTypeEnum // 渠道类型
  _channelLevel?: number // 渠道层级，ALL 为 1
}

export interface OrgActiveParams {
  channelOrgId: string
  saleUserIds: string[]
  orgOrUserType: OrgTreeType
  rolePermission: PermissionRole
}
